/**
 * Sidebar icons for modules that ship one with the app. A section's icon is
 * normally uploaded in the admin panel; these fill in only while it has none,
 * so an uploaded icon always wins.
 */
export const BUILTIN_MODULE_ICONS: Readonly<Record<string, string>> = {
  chat: "/icons/interface-icons/shared/icon-3d-chat-menu.png",
};
